import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import FeedbackService from 'services/FeedbackService';
import RatingStars from '../RatingStars';
import { useStyles } from './styles';

export default function Header() {
  const classes = useStyles();
  const [stats, setStats] = useState({
    score: 0,
    total: 0,
  });
  const feedbackService = new FeedbackService();

  useEffect(() => {
    async function fetchPlatformStats() {
      try {
        const { data } = await feedbackService.getPlatformStats();

        setStats(data);
      } catch (e) {
        console.error(e);
      }
    }

    fetchPlatformStats();
  }, []);

  return (
    <Box textAlign="center">
      <img className={classes.image} src="/images/feedback-bg.svg" alt="User Feedback" />

      <Typography className={classes.primaryColor} variant="h4" gutterBottom={true}>
        <b>See what people are talking about Mind The Graph!</b>
      </Typography>

      <Typography gutterBottom={true}>
        Feedback collected from our social media and support.
      </Typography>
      <Typography gutterBottom={true}>Feel free to comment or talk to us.</Typography>

      <Divider className={classes.divider} />

      <RatingStars className={classes.ratingStars} size="big" value={Math.ceil(stats.score / 2)} />

      <Typography variant="h6">{stats.total} Reviews</Typography>
    </Box>
  );
}
